import URLSearchParams from 'url-search-params';

export default class UtmData {
  constructor(data) {
    this.constructor.setStorage('utm_source');
    this.constructor.setStorage('utm_campaign');
    this.constructor.setStorage('utm_medium');
    this.constructor.setStorage('utm_term');

    if (window.localStorage.getItem('utm_source')) {
      data.utm_source = window.localStorage.getItem('utm_source');
    }

    if (window.localStorage.getItem('utm_campaign')) {
      data.utm_campaign = window.localStorage.getItem('utm_campaign');
    }

    if (window.localStorage.getItem('utm_medium')) {
      data.utm_medium = window.localStorage.getItem('utm_medium');
    }

    if (window.localStorage.getItem('utm_term')) {
      data.utm_term = window.localStorage.getItem('utm_term');
    }

    if (window.localStorage.getItem('leadsource')) {
      data.leadsource = window.localStorage.getItem('leadsource');
    }
  }

  static setStorage(name) {
    const params = new URLSearchParams(window.location.search);
    let result = false;

    if (params.has(name)) {
      result = params.get(name);
      window.localStorage.setItem(name, result);

      if (name === 'utm_source') {
        window.localStorage.setItem('leadsource', result);
      }
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./base/script/utmData.js